import React from "react";
import { useAppContext } from "store/context";
import { useDocumentData } from "react-firebase-hooks/firestore";
import AccountMenu from "./AccountMenu";

const AccountMenuContainer = () => {
  const { firebase, station } = useAppContext();

  const [data, loading] = useDocumentData(firebase.firestore().collection("devices").doc(station.id));

  if (loading || !data) {
    return null;
  }

  return <AccountMenu nickname={data.device_nickname} />;
};

export default AccountMenuContainer;
